type Props = {
  values: readonly number[];
  mutedValues?: readonly number[];
  disabled?: boolean;
  onValue: (value: number) => void;
  onErase: () => void;
};

export function NumberPad({ values, mutedValues = [], disabled = false, onValue, onErase }: Props) {
  return (
    <div className="number-pad" aria-label="Number pad">
      {values.map((value) => {
        const muted = mutedValues.includes(value);
        return (
          <button
            type="button"
            key={value}
            disabled={disabled}
            aria-label={`Enter ${value}${muted ? ', already in selected box' : ''}`}
            data-box-invalid={muted || undefined}
            className={muted ? 'number-pad__value--invalid' : undefined}
            onClick={() => onValue(value)}
          >
            {value}
          </button>
        );
      })}
      <button type="button" disabled={disabled} aria-label="Erase selected cell" onClick={onErase}>
        <span aria-hidden="true">⌫</span>
        <small>Erase</small>
      </button>
    </div>
  );
}
